import React from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core';
import Routes from './components/Routes';

const theme = createTheme({
  spacing: 4,
  palette: {
    common: {
      black: '#000000',
      white: '#FFFFFF',
    },
    primary: {
      main: '#D60A00',
      dark: '#FF0E02',
      light: '#FFE5E4',
      contrastText: '#6F6F78',
    },
    secondary: {
      main: '#6F6F78',
      dark: '#252528',
      light: '#DBDBDB',
      contrastText: '#6F6F78',
    },
  },
  typography: {
    fontFamily: [
      'Source Sans Pro'
    ].join(','),
  },
  buttonLabel: {
    color: 'white',
    textTransform: 'none',
    fontWeight: 'bold',
  },
});

theme.typography.h1 = {
  fontFamily: 'Conthrax Semibold',
  fontSize: '2.5rem',
  lineHeight: '3rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '2rem',
    lineHeight: '2.5rem',
  },
};
theme.typography.h2 = {
  fontFamily: 'Conthrax Semibold',
  fontSize: '2rem',
  lineHeight: '2.5rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
};
theme.typography.h3 = {
  fontFamily: 'Neue Plak Wide Semibold',
  fontSize: '1.5rem',
  lineHeight: '2rem',
  letterSpacing: '0',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
  },
};
theme.typography.h4 = {
  fontFamily: 'Neue Plak Wide Semibold',
  fontSize: '1.125rem',
  lineHeight: '1.5rem',
  letterSpacing: '0',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
    lineHeight: '1.4rem',
  },
};
theme.typography.h5 = {
  fontFamily: 'Neue Plak Wide Regular',
  fontSize: '1.125rem',
  lineHeight: '1.5rem',
  letterSpacing: '0',
  [theme.breakpoints.down('sm')]: {

  },
};
theme.typography.body1 = {
  fontSize: '1rem',
  lineHeight: '1.35rem',
  letterSpacing: '0',
  fontFamily: 'Neue Plak Wide Regular',
  [theme.breakpoints.down('sm')]: {

  },
};
theme.typography.body2 = {
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  letterSpacing: '0',
  fontFamily: 'Neue Plak Wide Regular',
  [theme.breakpoints.down('sm')]: {

  }
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Routes />
    </ThemeProvider>
  );
}